import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Mic, Menu, X } from 'lucide-react';
import { useState } from 'react';
import SocialLinks from '@/components/SocialLinks';

const Navbar = () => {
  const { isAuthenticated } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="nav-glass fixed top-0 left-0 right-0 z-50" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center" data-testid="navbar-logo">
            <img 
              src="/logo-full.png" 
              alt="EpisodeKit" 
              className="h-8 w-auto"
            />
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <Link to="/#features" className="text-neutral-400 hover:text-white transition-colors">
              Features
            </Link>
            <Link to="/pricing" className="text-neutral-400 hover:text-white transition-colors">
              Pricing
            </Link>
            {isAuthenticated ? (
              <Link to="/dashboard">
                <Button className="btn-primary" data-testid="dashboard-btn">
                  Dashboard
                </Button>
              </Link>
            ) : (
              <div className="flex items-center gap-4">
                <Link to="/login" className="text-neutral-400 hover:text-white transition-colors" data-testid="login-link">
                  Login
                </Link>
                <SocialLinks className="hidden lg:flex" />
                <Link to="/register">
                  <Button className="btn-primary" data-testid="get-started-btn">
                    Get Started
                  </Button>
                </Link>
              </div>
            )}
          </nav>

          <button
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-neutral-800">
            <nav className="flex flex-col gap-4">
              <Link to="/#features" className="text-neutral-400 hover:text-white">
                Features
              </Link>
              <Link to="/pricing" className="text-neutral-400 hover:text-white">
                Pricing
              </Link>
              {isAuthenticated ? (
                <Link to="/dashboard">
                  <Button className="btn-primary w-full">Dashboard</Button>
                </Link>
              ) : (
                <>
                  <Link to="/login" className="text-neutral-400 hover:text-white">
                    Login
                  </Link>
                  <Link to="/register">
                    <Button className="btn-primary w-full">Get Started</Button>
                  </Link>
                  <div className="pt-2">
                    <SocialLinks size="md" />
                  </div>
                </>
              )}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
